import { DateTime } from "luxon";

export function isCouponValid(coupon, now = Date.now()) {
  const code = String(coupon.code || "").trim().toLowerCase();
  const amount = Number(coupon.amount);
  if (!code || code.startsWith("wlk") || !Number.isFinite(amount) || amount <= 0) {
    return false;
  }

  // WooCommerce keeps the face value after redemption; the usage limit
  // determines whether a coupon has been exhausted. Null/zero means unlimited.
  const usageCount = Number(coupon.usage_count ?? 0);
  const usageLimit = Number(coupon.usage_limit ?? 0);
  if (
    !Number.isFinite(usageCount) || usageCount < 0 ||
    !Number.isFinite(usageLimit) || usageLimit < 0 ||
    (usageLimit > 0 && usageCount >= usageLimit)
  ) {
    return false;
  }

  // Prefer Woo's GMT value so validity does not depend on the browser timezone.
  const expiry = coupon.date_expires_gmt || coupon.date_expires;
  if (expiry) {
    const expiresAt = DateTime.fromISO(expiry, {
      zone: coupon.date_expires_gmt ? "utc" : "Europe/Bucharest",
    });
    if (!expiresAt.isValid || expiresAt.toMillis() <= now) return false;
  }

  // usage_limit_per_user cannot be treated as a global limit: other customers
  // may still use a reusable coupon even when one customer has reached it.
  return true;
}
